import { faArrowLeft, faCheck, faTrash, faUnlockAlt } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Modal, Space, Typography } from "antd"
import { useEffect, useState } from "react"
import { canRemoveRole } from "../../../domain/roles/roles"
import { useGetRoleByIdQuery, usePermissionsQuery } from "../../../domain/roles/rolesQueries"
import LabeledSwitch from "../../common/LabeledSwitch"
import VSpace from "../../common/VSpace"
import RemoveRoleModal from "./RemoveRoleModal"

const { Title, Text } = Typography

type Props = {
  roleId: number
  isOpen: boolean
  onCancel: () => void
  onOk: (permissions: string[]) => void
  onDelete: () => void
}

const RolePermissionsModal = ({ roleId, isOpen, onCancel, onOk, onDelete }: Props) => {
  const [permissionStates, setPermissionsStates] = useState<{ [key: string]: boolean }>({})
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false)

  const roleQuery = useGetRoleByIdQuery(roleId)
  const permissionsQuery = usePermissionsQuery()

  const role = roleQuery.data
  const permissions = permissionsQuery.data || []
  const hasRolePermissionsChange = Object.keys(permissionStates).some(key => permissionStates[key] !== role?.permissions.includes(key))

  const saveRolePermissions = () => {
    const permissions = Object.keys(permissionStates).filter(key => permissionStates[key] === true)
    onOk(permissions)
  }

  useEffect(() => {
    if (permissionsQuery.data) {
      const permissionsStates: { [key: string]: boolean } = {}
      permissionsQuery.data.forEach(permission => {
        permissionsStates[permission.name] = role?.permissions.includes(permission.name) || false
      })

      setPermissionsStates(permissionsStates)
    }
  }, [permissionsQuery.data, roleQuery.data])

  return <>
    <Modal
      title={<Space><FontAwesomeIcon icon={faUnlockAlt} /><Title level={4} style={{ marginBottom: 0 }}>Role Permissions</Title></Space>}
      open={isOpen}
      footer={
        [
          <Space key="actions">
            <Button onClick={onCancel} icon={<FontAwesomeIcon icon={faArrowLeft} />}>Cancel</Button>
            <Button danger onClick={() => setIsRemoveModalOpen(true)} disabled={!canRemoveRole(role?.rolename)} icon={<FontAwesomeIcon icon={faTrash} />}>Remove Role</Button>
            <Button type="primary" onClick={saveRolePermissions} disabled={!hasRolePermissionsChange} icon={<FontAwesomeIcon icon={faCheck} />}>Save</Button>
          </Space>
        ]
      }
      onCancel={onCancel}
    >
      <VSpace>
        <label>Estimator Role Permissions:</label>
        {
          permissions.map((permission, index) => (
            <VSpace key={index}>
              <LabeledSwitch 
                label={permission.name} 
                value={permissionStates[permission.name]} 
                onChange={value => setPermissionsStates({ ...permissionStates, [permission.name]: value })}
              />
              <Text type="secondary">{permission.description}</Text>
            </VSpace>
          ))
        }
      </VSpace>
    </Modal>
    
    <RemoveRoleModal 
      isOpen={isRemoveModalOpen}
      onOk={() => {
        onDelete()
        setIsRemoveModalOpen(false)
      }}
      onClose={() => setIsRemoveModalOpen(false)}
    />
  </>
}

export default RolePermissionsModal